import "babel-polyfill";
import "./configure";
import "./main.css";
import { loadPolyfills } from "./polyfills";
import { initEnvVariables } from "./utilities/appEnvVariables";

loadPolyfills()
  .then(() => {
    initEnvVariables();

    return import(
      /* webpackChunkName: "app-main" */
      "./bootstrapper"
    );
  })
  .then(({ bootstrapApplication }) => {
    // eslint-disable-next-line
    return bootstrapApplication().catch(console.error);
  })
  .then(() => {
    // this polyfill is for lazy loading images in older browsers, and is needed
    // even in newer browsers to allow images in noscript tags to show. This polyfill
    // must be loaded after rehydration completes rather than before.
    require("loading-attribute-polyfill");
  });
